import { changeSearchProduct } from '@/features/pos/components/ProductCatalog/utils/changeSearchProduct'
import IconButton from '@/features/ui/buttons/components/IconButton'
import CloseIcon from '@/features/ui/icons/components/CloseIcon'
import { FC } from 'react'

const ClearButton: FC = () => {
    const handlePress = () => changeSearchProduct('')

    return (
        <IconButton Icon={CloseIcon} mode="rounded" size={24} iconSize={16} onPress={handlePress} />
    )
}

export default ClearButton
